import { useEffect, useRef } from 'react';

export function useTabIndex<T extends HTMLElement = HTMLElement>(
  tabIndex: number | undefined,
) {
  let ref = useRef<T>(null);
  useEffect(() => {
    if (ref.current) {
      if (tabIndex == null) {
        ref.current.removeAttribute('tabIndex');
      } else {
        ref.current.tabIndex = tabIndex;
      }
    }
  }, [tabIndex]);
  return ref;
}
